export enum FeatureToggleType {
  disableCurrencyDisplay = 'disableCurrencyDisplay',
  disableLeaveGameBtn = 'disableLeaveGameBtn',
  disableLeaveGameBtnByRedirectUrlNotExisted = 'disableLeaveGameBtnByRedirectUrlNotExisted',
  disableRTPDisplay = 'disableRTPDisplay',
  disableFunkyGameLogo = 'disableFunkyGameLogo',
  disableHistoryList = 'disableHistoryList',
  disableChangePose = 'disableChangePose',
  disableTutorial = 'disableTutorial',
  disableBuyBonus = 'disableBuyBonus',
  enableRetryGetBalance = 'enableRetryGetBalance',
  disableVideoRecording = 'disableVideoRecording',
  displayRefNoWhenPlacedOrder = 'displayRefNoWhenPlacedOrder',
  enablePlaceOrderInterval = 'enablePlaceOrderInterval',
  enableSessionWinLose = 'enableSessionWinLose',
  enableSessionTime = 'enableSessionTime',
  disableAutoPlay = 'disableAutoPlay',
  disableTurboMode = 'disableTurboMode',
  enableReplaySlotOningGame = 'enableReplaySlotOningGame',
}
